"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PSQMultiChoiceMultiAnswer = void 0;
require("./PSQMultiChoiceMultiAnswer.css");
var React = require("react");
var constants = require("../../shared/code/Constants");
var PsqHelper_1 = require("../../shared/code/PsqHelper");
var panel_1 = require("@csod/panel");
var checkbox_1 = require("@csod/checkbox");
var image_1 = require("@csod/image");
var text_1 = require("@csod/text");
var RichTextViewer_1 = require("../RichTextViewer/RichTextViewer");
var PSQMultiChoiceMultiAnswer = (function (_super) {
    __extends(PSQMultiChoiceMultiAnswer, _super);
    function PSQMultiChoiceMultiAnswer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            options: _this.props.question.options,
            dataTag: ''
        };
        _this._onChange = function (value, id) {
            _this.props.question.errorMessage = "";
            _this.props.question.options.find(function (option) { return option.responseId === id; }).isChecked = value;
            _this.setState({ options: _this.props.question.options, dataTag: '' });
            var newOptions = _this.state.options.map(function (option) {
                return __assign({}, option);
            });
            _this.props.onChange(newOptions, _this.props.question.questionId);
        };
        _this.getImage = function (imageUrl) {
            var isVisible = imageUrl.length > 0;
            return (isVisible
                ? React.createElement(image_1.Image, { src: imageUrl, fallbackSrc: imageUrl, size: "Responsive", tooltip: "", alt: "", cornerStyle: "None", hasOverlay: false, overlayColor: "Black", overlayStrength: "Light", tag: "tag" })
                : null);
        };
        _this.getRichTextViewer = function () {
            var formattedQuestion = PsqHelper_1.PsqHelper.getLabel(_this.props.question);
            return (React.createElement(RichTextViewer_1.RichTextViewer, { id: 'question' + _this.props.question.questionId, html: formattedQuestion.valueOf(), allowedTags: constants.PRTV_ALLOWED_TAGS, allowedAttributes: constants.PRTV_ALLOWED_ATTRIBUTES }));
        };
        _this.getCheckbox = function (option, dataTag) {
            return (React.createElement(checkbox_1.Checkbox, { id: 'option' + option.responseId, label: option.text, isChecked: option.isChecked, showLabel: true, tag: dataTag, onChange: function (val) { _this._onChange(val, option.responseId); } }));
        };
        _this._onChange = _this._onChange.bind(_this);
        return _this;
    }
    PSQMultiChoiceMultiAnswer.prototype.componentWillReceiveProps = function (nextProps) {
        if (!!nextProps.question.errorMessage) {
            this.setState({ dataTag: 'psq-error' });
        }
    };
    PSQMultiChoiceMultiAnswer.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "psqmultichoicemultianswer" },
            this.getImage(this.props.question.attachment),
            this.getRichTextViewer(),
            React.createElement("fieldset", { "aria-labelledby": this.props.question.questionId }, this.props.question.options.map(function (option) {
                return React.createElement(panel_1.Panel, { paddingTop: "Small" }, _this.getCheckbox(option, _this.state.dataTag));
            })),
            React.createElement(text_1.Text, { text: this.props.question.errorMessage, color: "Error" })));
    };
    ;
    PSQMultiChoiceMultiAnswer.defaultProps = {
        question: null,
        errorMessage: "",
        onChange: function () { }
    };
    return PSQMultiChoiceMultiAnswer;
}(React.Component));
exports.PSQMultiChoiceMultiAnswer = PSQMultiChoiceMultiAnswer;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["PSQMultiChoiceMultiAnswer"] = [];


//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/2c51a2fe812ded8e/src/.tmp/PSQMultiChoiceMultiAnswer/PSQMultiChoiceMultiAnswer.js
// module id = 779
// module chunks = 0